import type { LucideIcon } from 'lucide-react';
import type { Family } from '@nexus/skill-workflow';

import {
  Flag,
  Hash,
  Mail,
  Mic,
  Globe,
  Image,
  Users,
  Video,
  CalendarPlus,
  Repeat,
  Server,
  Share2,
  FileText,
  Hourglass,
  PhoneCall,
  HelpCircle,
  ListChecks,
  StickyNote,
  ShieldCheck,
  MessageSquare,
  FileSpreadsheet,
} from '../../../components/lucide-icon';

export const STEP_ICONS: Record<string, LucideIcon> = {
  'ask.yes_no': HelpCircle,
  'ask.choice': ListChecks,
  'ask.number': Hash,
  'ask.free': Mic,
  'show.image': Image,
  'show.video': Video,
  'show.document_page': FileText,
  'show.card': StickyNote,
  'show.web': Globe,
  'act.email': Mail,
  'act.teams_message': MessageSquare,
  'act.calendar_invite': CalendarPlus,
  'act.hubspot': Users,
  'act.http': Server,
  'act.report_pdf': FileText,
  'act.report_xlsx': FileSpreadsheet,
  'flow.repeat': Repeat,
  'flow.wait': Hourglass,
  'flow.end': Flag,
  'flow.start_workflow': Share2,
  'escalate.call': PhoneCall,
  'escalate.signoff': ShieldCheck,
};

/** The icon for a step type. A plain lookup would return Object's own functions for names like "constructor". */
export function stepIcon(type: string | null | undefined): LucideIcon {
  return type && Object.prototype.hasOwnProperty.call(STEP_ICONS, type) ? STEP_ICONS[type] : StickyNote;
}

export type FamilyColor = 'info' | 'success' | 'warning' | 'error' | 'primary';

export const FAMILY_COLOR: Record<Family, FamilyColor> = {
  ask: 'info',
  show: 'warning',
  act: 'success',
  flow: 'primary',
  escalate: 'error',
};
